// extracted by mini-css-extract-plugin
module.exports = {"container":"DateTimeInput_container__2o-nn","placeholder":"DateTimeInput_placeholder__1RTe-"};